var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "24px",
    viewBox: "0 0 11 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9949388 7.66187755H7.25044898V5.20604082c0-.92228572.61126531-1.13730613 1.04179592-1.13730613h2.642449V.01420409L7.2955102 0C3.25567347 0 2.33632653 3.024 2.33632653 4.95918367v2.70269388H0v4.17795915h2.33632653v11.8222041h4.91412245V11.8398367h3.31591832l.4285715-4.17795915z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.9d542b2e30563f5d0d15cafa0e5c9165.svg";
export { ForwardRef as ReactComponent };